export const pageConstants = {
  PAGE_LOAD: '[Page] Load',
  PAGE_LOAD_SUCCESS: '[Page] Load success',
  PAGE_LOAD_FAILURE: '[Page] Load failure',
  PAGE_RESET: '[Page] Reset'
}
